{
  "level": "eb06",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:eb06",
    "objects": "AREAS.E3:eb06.e3",
    "mesh": "TREES.E3:eb06.e3"
  },
  "spawn_point": {
    "position": [
      2028.8655229512617,
      1952.1632641908016,
      394.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      2028.8655229512617,
      2052.163264190802,
      394.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      1947.2630615234375,
      1870.8956298828125,
      370.0
    ],
    "bbox_max": [
      2114.95654296875,
      2038.588623046875,
      665.0
    ],
    "vertex_count": 239,
    "vertices": [
      [
        1998.99072265625,
        2038.588623046875,
        410.0
      ],
      [
        1998.99072265625,
        2038.588623046875,
        410.0
      ],
      [
        2114.95654296875,
        1922.623291015625,
        410.0
      ],
      [
        2114.95654296875,
        1922.623291015625,
        410.0
      ],
      [
        2032.224853515625,
        2005.354736328125,
        410.0
      ],
      [
        2028.689208984375,
        2008.8902587890625,
        410.0
      ],
      [
        2085.258056640625,
        1952.32177734375,
        410.0
      ],
      [
        2081.72216796875,
        1955.8572998046875,
        410.0
      ],
      [
        2081.72216796875,
        1955.8572998046875,
        405.0
      ],
      [
        2081.72216796875,
        1955.8572998046875,
        410.0
      ],
      [
        2085.258056640625,
        1952.32177734375,
        410.0
      ],
      [
        2085.258056640625,
        1952.32177734375,
        405.0
      ],
      [
        2032.224853515625,
        2005.354736328125,
        410.0
      ],
      [
        2032.224853515625,
        2005.354736328125,
        405.0
      ],
      [
        2028.689208984375,
        2008.8902587890625,
        405.0
      ],
      [
        2028.689208984375,
        2008.8902587890625,
        410.0
      ],
      [
        2017.9737548828125,
        2019.60595703125,
        640.0
      ],
      [
        2025.044677734375,
        2012.53466796875,
        640.0
      ],
      [
        2088.90234375,
        1948.677490234375,
        640.0
      ],
      [
        2096.6806640625,
        1940.899169921875,
        640.0
      ],
      [
        2025.044677734375,
        2012.53466796875,
        645.0
      ],
      [
        2025.044677734375,
        2012.53466796875,
        640.0
      ],
      [
        2088.90234375,
        1948.677490234375,
        640.0
      ],
      [
        2088.90234375,
        1948.677490234375,
        645.0
      ],
      [
        2001.1121826171875,
        1958.685791015625,
        372.5
      ],
      [
        2036.467529296875,
        1923.3304443359375,
        372.5
      ],
      [
        2001.1121826171875,
        1958.685791015625,
        372.5
      ],
      [
        1972.827880859375,
        1930.4014892578125,
        372.5
      ],
      [
        2008.1832275390625,
        1895.046142578125,
        372.5
      ],
      [
        2036.467529296875,
        1923.3304443359375,
        372.5
      ],
      [
        2045.659912109375,
        1878.78271484375,
        372.5
      ],
      [
        2059.802001953125,
        1892.9248046875,
        372.5
      ],
      [
        2064.802001953125,
        1894.9959716796875,
        372.5
      ],
      [
        2059.802001953125,
        1892.9248046875,
        372.5
      ],
      [
        2064.802001953125,
        1894.9959716796875,
        370.0
      ],
      [
        2032.224853515625,
        1893.6319580078125,
        372.5
      ],
      [
        2040.0030517578125,
        1885.853759765625,
        372.5
      ],
      [
        2024.4466552734375,
        1885.853759765625,
        372.5
      ],
      [
        2032.224853515625,
        1893.6319580078125,
        372.5
      ],
      [
        1969.2923583984375,
        1983.4345703125,
        372.5
      ],
      [
        1955.1502685546875,
        1969.2923583984375,
        372.5
      ],
      [
        1971.3634033203125,
        1988.4345703125,
        370.0
      ],
      [
        1969.2923583984375,
        1983.4345703125,
        372.5
      ],
      [
        1971.3634033203125,
        1988.4345703125,
        372.5
      ],
      [
        1962.2213134765625,
        1963.635498046875,
        372.5
      ],
      [
        1969.99951171875,
        1955.8572998046875,
        372.5
      ],
      [
        1969.99951171875,
        1955.8572998046875,
        372.5
      ],
      [
        1962.2213134765625,
        1948.0792236328125,
        372.5
      ],
      [
        1963.635498046875,
        2003.2335205078125,
        372.5
      ],
      [
        1969.2923583984375,
        1997.57666015625,
        372.5
      ],
      [
        2073.944091796875,
        1892.9249267578125,
        372.5
      ],
      [
        2079.60107421875,
        1887.2679443359375,
        372.5
      ],
      [
        1972.2213134765625,
        1990.505615234375,
        372.5
      ],
      [
        1969.2923583984375,
        1997.57666015625,
        372.5
      ],
      [
        1972.2213134765625,
        1990.505615234375,
        372.5
      ],
      [
        2073.944091796875,
        1892.9249267578125,
        372.5
      ],
      [
        2066.873046875,
        1895.853759765625,
        372.5
      ],
      [
        2066.873046875,
        1895.853759765625,
        372.5
      ],
      [
        2010.4439697265625,
        1934.687255859375,
        375.0
      ],
      [
        2059.802001953125,
        1892.9248046875,
        374.5291748046875
      ],
      [
        2064.802001953125,
        1894.9959716796875,
        372.5
      ],
      [
        2064.802001953125,
        1894.9959716796875,
        374.00732421875
      ],
      [
        2064.802001953125,
        1894.9959716796875,
        375.0
      ],
      [
        2066.873291015625,
        1892.9248046875,
        373.79107666015625
      ],
      [
        2066.287109375,
        1893.510986328125,
        374.0
      ],
      [
        2068.84521484375,
        1890.9530029296875,
        373.5
      ],
      [
        2066.873291015625,
        1892.9248046875,
        373.79107666015625
      ],
      [
        1969.2923583984375,
        1983.4345703125,
        374.52923583984375
      ],
      [
        1971.3634033203125,
        1988.4345703125,
        374.00732421875
      ],
      [
        1971.3634033203125,
        1988.4345703125,
        372.5
      ],
      [
        1971.3634033203125,
        1988.4345703125,
        375.0
      ],
      [
        1969.8785400390625,
        1989.91943359375,
        374.0
      ],
      [
        1969.2923583984375,
        1990.505615234375,
        373.79107666015625
      ],
      [
        1969.2923583984375,
        1990.505615234375,
        373.79107666015625
      ],
      [
        1967.3206787109375,
        1992.477294921875,
        373.5
      ],
      [
        1972.2213134765625,
        1990.505615234375,
        373.7911376953125
      ],
      [
        1971.3634033203125,
        1988.4345703125,
        373.2691650390625
      ],
      [
        2066.873046875,
        1895.853759765625,
        373.7911376953125
      ],
      [
        2064.802001953125,
        1894.9959716796875,
        373.2691650390625
      ],
      [
        1996.1624755859375,
        1885.853759765625,
        662.0001220703125
      ],
      [
        2006.76904296875,
        1875.2471923828125,
        662.0001220703125
      ],
      [
        1953.736083984375,
        1928.2801513671875,
        661.9998168945312
      ],
      [
        1964.3426513671875,
        1917.673583984375,
        662.0001220703125
      ],
      [
        1974.94921875,
        1907.0670166015625,
        662.0000610351562
      ],
      [
        1985.5557861328125,
        1896.4603271484375,
        662.0000610351562
      ],
      [
        2018.1917724609375,
        1870.8956298828125,
        659.0000610351562
      ],
      [
        2010.3045654296875,
        1878.78271484375,
        659.0
      ],
      [
        1967.878173828125,
        1921.2091064453125,
        658.9999389648438
      ],
      [
        1978.4847412109375,
        1910.6025390625,
        659.0
      ],
      [
        1989.0914306640625,
        1899.9959716796875,
        659.0000610351562
      ],
      [
        1999.697998046875,
        1889.3892822265625,
        659.0000610351562
      ],
      [
        1947.2630615234375,
        1941.82421875,
        659.0
      ],
      [
        1957.2716064453125,
        1931.815673828125,
        659.0
      ],
      [
        1999.697998046875,
        1889.3892822265625,
        659.0000610351562
      ],
      [
        1996.1624755859375,
        1885.853759765625,
        662.0001220703125
      ],
      [
        1967.878173828125,
        1921.2091064453125,
        658.9999389648438
      ],
      [
        1964.3426513671875,
        1917.673583984375,
        662.0001220703125
      ],
      [
        1957.2716064453125,
        1931.815673828125,
        659.0
      ],
      [
        1953.736083984375,
        1928.2801513671875,
        661.9998168945312
      ],
      [
        2010.3045654296875,
        1878.78271484375,
        659.0
      ],
      [
        2006.76904296875,
        1875.2471923828125,
        662.0001220703125
      ],
      [
        1972.8280029296875,
        1916.25927734375,
        658.9999389648438
      ],
      [
        1972.8280029296875,
        1916.25927734375,
        665.0
      ],
      [
        1994.0411376953125,
        1895.0462646484375,
        659.0000610351562
      ],
      [
        1994.0411376953125,
        1895.0462646484375,
        665.0
      ],
      [
        2079.003173828125,
        1923.2218017578125,
        370.0
      ],
      [
        2000.295166015625,
        2001.92724609375,
        370.0
      ],
      [
        2000.295166015625,
        2001.92724609375,
        370.0
      ],
      [
        2000.295166015625,
        2001.92724609375,
        385.0
      ],
      [
        2000.2950439453125,
        2001.92724609375,
        650.0
      ],
      [
        2000.2950439453125,
        2001.92724609375,
        660.0
      ],
      [
        2000.2950439453125,
        2001.92724609375,
        413.7496337890625
      ],
      [
        2000.2950439453125,
        2001.92724609375,
        470.0
      ],
      [
        2000.2950439453125,
        2001.92724609375,
        590.0
      ],
      [
        2000.2950439453125,
        2001.92724609375,
        650.0
      ],
      [
        2000.2950439453125,
        2001.92724609375,
        530.0
      ],
      [
        2000.2950439453125,
        2001.92724609375,
        590.0
      ],
      [
        2000.2950439453125,
        2001.92724609375,
        470.0
      ],
      [
        2000.2950439453125,
        2001.92724609375,
        530.0
      ],
      [
        1981.311767578125,
        2020.9097900390625,
        385.0
      ],
      [
        2000.295166015625,
        2001.92724609375,
        385.0
      ],
      [
        1981.311767578125,
        2020.90966796875,
        410.0
      ],
      [
        1981.311767578125,
        2020.9097900390625,
        413.74951171875
      ],
      [
        1981.311767578125,
        2020.90966796875,
        410.0
      ],
      [
        1981.311767578125,
        2020.9097900390625,
        385.0
      ],
      [
        2000.2950439453125,
        2001.92724609375,
        640.0
      ],
      [
        2007.3662109375,
        1994.856201171875,
        640.0
      ],
      [
        2007.3662109375,
        1994.856201171875,
        645.0
      ],
      [
        2007.3662109375,
        1994.856201171875,
        640.0
      ],
      [
        2079.003173828125,
        1923.2218017578125,
        385.0
      ],
      [
        2079.003173828125,
        1923.2218017578125,
        370.0
      ],
      [
        2079.003173828125,
        1923.2216796875,
        650.0
      ],
      [
        2079.003173828125,
        1923.2216796875,
        660.0
      ],
      [
        2079.003173828125,
        1923.2216796875,
        413.75006103515625
      ],
      [
        2079.003173828125,
        1923.2216796875,
        470.0
      ],
      [
        2079.003173828125,
        1923.2216796875,
        590.0
      ],
      [
        2079.003173828125,
        1923.2216796875,
        650.0
      ],
      [
        2079.003173828125,
        1923.2216796875,
        530.0
      ],
      [
        2079.003173828125,
        1923.2216796875,
        590.0
      ],
      [
        2079.003173828125,
        1923.2216796875,
        470.0
      ],
      [
        2079.003173828125,
        1923.2216796875,
        530.0
      ],
      [
        2079.003173828125,
        1923.2218017578125,
        385.0
      ],
      [
        2097.279296875,
        1904.9462890625,
        385.0
      ],
      [
        2097.279296875,
        1904.9461669921875,
        410.0
      ],
      [
        2097.279296875,
        1904.9462890625,
        413.75018310546875
      ],
      [
        2097.279296875,
        1904.9462890625,
        385.0
      ],
      [
        2097.279296875,
        1904.9461669921875,
        410.0
      ],
      [
        2071.224609375,
        1930.999755859375,
        640.0
      ],
      [
        2079.003173828125,
        1923.2216796875,
        640.0
      ],
      [
        2071.224609375,
        1930.999755859375,
        640.0
      ],
      [
        2071.224609375,
        1930.999755859375,
        645.0
      ],
      [
        2032.224365234375,
        1969.9989013671875,
        455.62469482421875
      ],
      [
        2046.36669921875,
        1955.8570556640625,
        455.62481689453125
      ],
      [
        2032.224365234375,
        1969.9989013671875,
        575.6246948242188
      ],
      [
        2046.36669921875,
        1955.8570556640625,
        575.6248168945312
      ],
      [
        2032.224365234375,
        1969.9989013671875,
        590.0
      ],
      [
        2046.36669921875,
        1955.8570556640625,
        590.0
      ],
      [
        2032.224365234375,
        1969.9989013671875,
        575.6246948242188
      ],
      [
        2032.224365234375,
        1969.9989013671875,
        590.0
      ],
      [
        2046.36669921875,
        1955.8570556640625,
        590.0
      ],
      [
        2046.36669921875,
        1955.8570556640625,
        575.6248168945312
      ],
      [
        2021.6175537109375,
        1980.60546875,
        635.6246337890625
      ],
      [
        2032.224365234375,
        1969.9989013671875,
        635.6246948242188
      ],
      [
        2046.36669921875,
        1955.8570556640625,
        635.6248168945312
      ],
      [
        2056.973388671875,
        1945.25048828125,
        635.6248779296875
      ],
      [
        2032.224365234375,
        1969.9989013671875,
        650.0
      ],
      [
        2032.224365234375,
        1969.9989013671875,
        635.6246948242188
      ],
      [
        2021.6175537109375,
        1980.60546875,
        635.6246337890625
      ],
      [
        2021.6175537109375,
        1980.60546875,
        650.0
      ],
      [
        2046.36669921875,
        1955.8570556640625,
        635.6248168945312
      ],
      [
        2046.36669921875,
        1955.8570556640625,
        650.0
      ],
      [
        2056.973388671875,
        1945.25048828125,
        650.0
      ],
      [
        2056.973388671875,
        1945.25048828125,
        635.6248779296875
      ],
      [
        2032.224365234375,
        1969.9989013671875,
        470.0
      ],
      [
        2046.36669921875,
        1955.8570556640625,
        470.0
      ],
      [
        2032.224365234375,
        1969.9989013671875,
        455.62469482421875
      ],
      [
        2032.224365234375,
        1969.9989013671875,
        470.0
      ],
      [
        2046.36669921875,
        1955.8570556640625,
        470.0
      ],
      [
        2046.36669921875,
        1955.8570556640625,
        455.62481689453125
      ],
      [
        2021.6175537109375,
        1980.60546875,
        515.6246337890625
      ],
      [
        2032.224365234375,
        1969.9989013671875,
        515.6246948242188
      ],
      [
        2046.36669921875,
        1955.8570556640625,
        515.6248168945312
      ],
      [
        2056.973388671875,
        1945.25048828125,
        515.6248779296875
      ],
      [
        2021.6175537109375,
        1980.60546875,
        530.0
      ],
      [
        2032.224365234375,
        1969.9989013671875,
        530.0
      ],
      [
        2046.36669921875,
        1955.8570556640625,
        530.0
      ],
      [
        2056.973388671875,
        1945.25048828125,
        530.0
      ],
      [
        2032.224365234375,
        1969.9989013671875,
        530.0
      ],
      [
        2032.224365234375,
        1969.9989013671875,
        515.6246948242188
      ],
      [
        2021.6175537109375,
        1980.60546875,
        515.6246337890625
      ],
      [
        2021.6175537109375,
        1980.60546875,
        530.0
      ],
      [
        2046.36669921875,
        1955.8570556640625,
        515.6248168945312
      ],
      [
        2046.36669921875,
        1955.8570556640625,
        530.0
      ],
      [
        2056.973388671875,
        1945.25048828125,
        530.0
      ],
      [
        2056.973388671875,
        1945.25048828125,
        515.6248779296875
      ],
      [
        2043.5382080078125,
        1958.6854248046875,
        370.8487854003906
      ],
      [
        2048.488037109375,
        1953.7357177734375,
        370.8487854003906
      ],
      [
        2030.1029052734375,
        1972.1201171875,
        370.8485107421875
      ],
      [
        2035.052978515625,
        1967.170654296875,
        370.8487548828125
      ],
      [
        2043.5382080078125,
        1958.6854248046875,
        370.8487854003906
      ],
      [
        2043.5382080078125,
        1958.6854248046875,
        370.0
      ],
      [
        2048.488037109375,
        1953.7357177734375,
        370.0
      ],
      [
        2048.488037109375,
        1953.7357177734375,
        370.8487854003906
      ],
      [
        2030.1029052734375,
        1972.1201171875,
        370.8485107421875
      ],
      [
        2030.1029052734375,
        1972.1201171875,
        370.0
      ],
      [
        2035.052978515625,
        1967.170654296875,
        370.0
      ],
      [
        2035.052978515625,
        1967.170654296875,
        370.8487548828125
      ],
      [
        2035.7598876953125,
        1966.4635009765625,
        370.8486328125
      ],
      [
        2035.7598876953125,
        1966.4635009765625,
        374.3486328125
      ],
      [
        2030.1029052734375,
        1972.1201171875,
        370.8485107421875
      ],
      [
        2030.1029052734375,
        1972.1201171875,
        374.3485107421875
      ],
      [
        2029.395751953125,
        1972.8271484375,
        374.3485107421875
      ],
      [
        2029.395751953125,
        1972.8271484375,
        370.8485107421875
      ],
      [
        2030.1029052734375,
        1972.1201171875,
        374.3485107421875
      ],
      [
        2029.395751953125,
        1972.8271484375,
        374.3485107421875
      ],
      [
        2035.052978515625,
        1967.170654296875,
        374.3487548828125
      ],
      [
        2035.052978515625,
        1967.170654296875,
        370.8487548828125
      ],
      [
        2035.7598876953125,
        1966.4635009765625,
        374.3486328125
      ],
      [
        2035.052978515625,
        1967.170654296875,
        374.3487548828125
      ],
      [
        2043.5382080078125,
        1958.6854248046875,
        370.8487854003906
      ],
      [
        2043.5382080078125,
        1958.6854248046875,
        374.3487854003906
      ],
      [
        2042.8311767578125,
        1959.392578125,
        374.3487854003906
      ],
      [
        2042.8311767578125,
        1959.392578125,
        370.8487854003906
      ],
      [
        2043.5382080078125,
        1958.6854248046875,
        374.3487854003906
      ],
      [
        2042.8311767578125,
        1959.392578125,
        374.3487854003906
      ],
      [
        2049.195068359375,
        1953.028564453125,
        370.8487854003906
      ],
      [
        2049.195068359375,
        1953.028564453125,
        374.3487854003906
      ],
      [
        2048.488037109375,
        1953.7357177734375,
        374.3487854003906
      ],
      [
        2048.488037109375,
        1953.7357177734375,
        370.8487854003906
      ],
      [
        2049.195068359375,
        1953.028564453125,
        374.3487854003906
      ],
      [
        2048.488037109375,
        1953.7357177734375,
        374.3487854003906
      ],
      [
        2075.46728515625,
        1919.6859130859375,
        382.0
      ],
      [
        2067.689208984375,
        1927.464111328125,
        382.0
      ],
      [
        2067.689208984375,
        1927.464111328125,
        382.0
      ],
      [
        2060.6181640625,
        1920.39306640625,
        382.0
      ],
      [
        1996.7606201171875,
        1998.3927001953125,
        382.0
      ],
      [
        2003.8316650390625,
        1991.3216552734375,
        382.0
      ],
      [
        2003.8316650390625,
        1991.3216552734375,
        382.0
      ],
      [
        1996.7606201171875,
        1984.2506103515625,
        382.0
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2875.0,
      "bbox_min": [
        1925.8643798828125,
        1849.496826171875,
        370.0
      ],
      "bbox_max": [
        2129.0986328125,
        2052.73095703125,
        667.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071062922477722,
        -0.7071073651313782,
        0.0
      ],
      "plane_d": 2855.0,
      "bbox_min": [
        1925.8643798828125,
        1849.496826171875,
        370.0
      ],
      "bbox_max": [
        2129.0986328125,
        2052.73095703125,
        667.5
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -385.0,
      "bbox_min": [
        1998.99072265625,
        1922.623291015625,
        385.0
      ],
      "bbox_max": [
        2129.0986328125,
        2052.73095703125,
        645.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071083784103394,
        0.707105278968811,
        0.0
      ],
      "plane_d": 136.006103515625,
      "bbox_min": [
        2017.9737548828125,
        1922.623291015625,
        385.0
      ],
      "bbox_max": [
        2129.0986328125,
        2023.032470703125,
        645.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 89.0,
      "bbox_min": [
        2028.689208984375,
        1952.32177734375,
        385.0
      ],
      "bbox_max": [
        2099.400146484375,
        2023.032470703125,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071050405502319,
        -0.7071085572242737,
        0.0
      ],
      "plane_d": -93.9930419921875,
      "bbox_min": [
        2085.258056640625,
        1952.32177734375,
        405.0
      ],
      "bbox_max": [
        2099.400146484375,
        1966.4638671875,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -19.0001220703125,
      "bbox_min": [
        2028.689208984375,
        1970.706787109375,
        385.0
      ],
      "bbox_max": [
        2069.27734375,
        2023.032470703125,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071050405502319,
        0.7071085572242737,
        0.0
      ],
      "plane_d": 13.992919921875,
      "bbox_min": [
        2028.689208984375,
        2008.8902587890625,
        405.0
      ],
      "bbox_max": [
        2042.83154296875,
        2023.032470703125,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 59.0,
      "bbox_min": [
        2047.0743408203125,
        1970.706787109375,
        385.0
      ],
      "bbox_max": [
        2069.27734375,
        1992.9100341796875,
        388.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 67.0001220703125,
      "bbox_min": [
        2060.50927734375,
        1970.706787109375,
        385.0
      ],
      "bbox_max": [
        2069.27734375,
        1979.474853515625,
        388.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -68.0,
      "bbox_min": [
        2066.166259765625,
        1970.706787109375,
        385.0
      ],
      "bbox_max": [
        2069.27734375,
        1973.8179931640625,
        388.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -388.5,
      "bbox_min": [
        2066.166259765625,
        1970.706787109375,
        388.0
      ],
      "bbox_max": [
        2069.27734375,
        1973.8179931640625,
        388.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31623297929763794,
        0.31623297929763794,
        0.8944236040115356
      ],
      "plane_d": -1625.372802734375,
      "bbox_min": [
        2067.86328125,
        1972.40380859375,
        388.0
      ],
      "bbox_max": [
        2069.27734375,
        1973.8179931640625,
        388.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071830630302429,
        -0.7070304751396179,
        0.0
      ],
      "plane_d": -60.3082275390625,
      "bbox_min": [
        2060.50927734375,
        1976.363525390625,
        385.0
      ],
      "bbox_max": [
        2063.62060546875,
        1979.474853515625,
        388.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -388.5,
      "bbox_min": [
        2060.50927734375,
        1976.363525390625,
        388.0
      ],
      "bbox_max": [
        2063.62060546875,
        1979.474853515625,
        388.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31623297929763794,
        0.31623297929763794,
        0.8944236040115356
      ],
      "plane_d": -1625.372802734375,
      "bbox_min": [
        2062.206298828125,
        1978.0606689453125,
        388.0
      ],
      "bbox_max": [
        2063.62060546875,
        1979.474853515625,
        388.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 48.0,
      "bbox_min": [
        2047.0743408203125,
        1984.141845703125,
        385.0
      ],
      "bbox_max": [
        2055.84228515625,
        1992.9100341796875,
        388.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7070813775062561,
        -0.7071322202682495,
        0.0
      ],
      "plane_d": -48.897216796875,
      "bbox_min": [
        2052.731201171875,
        1984.141845703125,
        385.0
      ],
      "bbox_max": [
        2055.84228515625,
        1987.2530517578125,
        388.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -388.5,
      "bbox_min": [
        2052.731201171875,
        1984.141845703125,
        388.0
      ],
      "bbox_max": [
        2055.84228515625,
        1987.2530517578125,
        388.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31626027822494507,
        0.3162056803703308,
        0.8944236040115356
      ],
      "plane_d": -1625.374755859375,
      "bbox_min": [
        2054.42822265625,
        1985.8387451171875,
        388.0
      ],
      "bbox_max": [
        2055.84228515625,
        1987.2530517578125,
        388.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.707055926322937,
        -0.7071576714515686,
        0.0
      ],
      "plane_d": -40.7945556640625,
      "bbox_min": [
        2047.0743408203125,
        1989.7987060546875,
        385.0
      ],
      "bbox_max": [
        2050.185546875,
        1992.9100341796875,
        388.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071322202682495,
        0.7070813775062561,
        0.0
      ],
      "plane_d": 40.1026611328125,
      "bbox_min": [
        2047.0743408203125,
        1989.7987060546875,
        385.0
      ],
      "bbox_max": [
        2050.185546875,
        1992.9100341796875,
        388.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -388.5,
      "bbox_min": [
        2047.0743408203125,
        1989.7987060546875,
        388.0
      ],
      "bbox_max": [
        2050.185546875,
        1992.9100341796875,
        388.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31622201204299927,
        0.3161128759384155,
        0.8944698572158813
      ],
      "plane_d": -1625.12890625,
      "bbox_min": [
        2048.771240234375,
        1991.49560546875,
        388.0
      ],
      "bbox_max": [
        2050.185546875,
        1992.9100341796875,
        388.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 640.0,
      "bbox_min": [
        2017.9737548828125,
        1940.899169921875,
        640.0
      ],
      "bbox_max": [
        2097.0341796875,
        2019.95947265625,
        645.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -8.845947265625,
      "bbox_min": [
        2025.044677734375,
        1948.677490234375,
        640.0
      ],
      "bbox_max": [
        2089.255859375,
        2012.888427734375,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.707109808921814,
        0.7071037888526917,
        0.0
      ],
      "plane_d": 99.1661376953125,
      "bbox_min": [
        2088.90234375,
        1948.677490234375,
        640.0
      ],
      "bbox_max": [
        2089.255859375,
        1949.031005859375,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071062922477722,
        0.7071073651313782,
        -0.0
      ],
      "plane_d": -2815.0,
      "bbox_min": [
        1925.8643798828125,
        1849.496826171875,
        370.0
      ],
      "bbox_max": [
        2114.95654296875,
        2038.5888671875,
        667.5
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -370.0,
      "bbox_min": [
        1925.8643798828125,
        1849.496826171875,
        370.0
      ],
      "bbox_max": [
        2086.672119140625,
        2010.3045654296875,
        667.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 665.0,
      "bbox_min": [
        1925.8643798828125,
        1849.496826171875,
        370.0
      ],
      "bbox_max": [
        2086.672119140625,
        2010.3045654296875,
        667.5
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.7071108222007751,
        0.7071027159690857,
        -0.0
      ],
      "plane_d": -2745.000244140625,
      "bbox_min": [
        1953.736083984375,
        1875.2471923828125,
        665.0
      ],
      "bbox_max": [
        2010.3045654296875,
        1931.815673828125,
        667.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -78.0,
      "bbox_min": [
        1953.736083984375,
        1875.2471923828125,
        665.0
      ],
      "bbox_max": [
        2010.3045654296875,
        1931.815673828125,
        667.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067094802856,
        0.7071067094802856,
        0.0
      ],
      "plane_d": 33.0,
      "bbox_min": [
        1953.736083984375,
        1917.673583984375,
        665.0
      ],
      "bbox_max": [
        1967.878173828125,
        1931.815673828125,
        667.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -18.0001220703125,
      "bbox_min": [
        1953.736083984375,
        1928.2801513671875,
        665.0
      ],
      "bbox_max": [
        1957.2716064453125,
        1931.815673828125,
        667.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067094802856,
        0.7071067094802856,
        0.0
      ],
      "plane_d": 93.0,
      "bbox_min": [
        2006.76904296875,
        1875.2471923828125,
        665.0
      ],
      "bbox_max": [
        2010.3045654296875,
        1878.78271484375,
        667.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 136.0,
      "bbox_min": [
        1925.8643798828125,
        1849.496826171875,
        370.0
      ],
      "bbox_max": [
        2086.672119140625,
        2010.3045654296875,
        665.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071077823638916,
        -0.7071058750152588,
        0.0
      ],
      "plane_d": 27.9962158203125,
      "bbox_min": [
        1925.8643798828125,
        1870.8956298828125,
        370.0
      ],
      "bbox_max": [
        2079.60107421875,
        2010.3045654296875,
        665.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -372.5,
      "bbox_min": [
        1947.2630615234375,
        1870.8956298828125,
        370.0
      ],
      "bbox_max": [
        2079.60107421875,
        2003.2335205078125,
        665.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2800.000244140625,
      "bbox_min": [
        1955.1502685546875,
        1878.78271484375,
        370.0
      ],
      "bbox_max": [
        2079.60107421875,
        2003.2335205078125,
        372.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 30.0,
      "bbox_min": [
        1955.1502685546875,
        1878.78271484375,
        370.0
      ],
      "bbox_max": [
        2064.802001953125,
        1988.4345703125,
        372.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        2008.1832275390625,
        1878.78271484375,
        370.0
      ],
      "bbox_max": [
        2064.802001953125,
        1923.3304443359375,
        372.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 118.0001220703125,
      "bbox_min": [
        2024.4466552734375,
        1878.78271484375,
        370.0
      ],
      "bbox_max": [
        2064.802001953125,
        1894.9959716796875,
        372.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826870620250702,
        0.9238780736923218,
        0.0
      ],
      "plane_d": -960.5721435546875,
      "bbox_min": [
        2059.802001953125,
        1892.9248046875,
        370.0
      ],
      "bbox_max": [
        2064.802001953125,
        1894.9959716796875,
        372.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2776.000244140625,
      "bbox_min": [
        2024.4466552734375,
        1885.853759765625,
        370.0
      ],
      "bbox_max": [
        2040.0030517578125,
        1893.6319580078125,
        372.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        2024.4466552734375,
        1885.853759765625,
        370.0
      ],
      "bbox_max": [
        2032.224853515625,
        1893.6319580078125,
        372.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071098685264587,
        -0.7071037888526917,
        0.0
      ],
      "plane_d": 9.988037109375,
      "bbox_min": [
        1955.1502685546875,
        1948.0792236328125,
        370.0
      ],
      "bbox_max": [
        1971.3634033203125,
        1988.4345703125,
        372.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238780736923218,
        -0.3826870620250702,
        0.0
      ],
      "plane_d": -1060.351318359375,
      "bbox_min": [
        1969.2923583984375,
        1983.4345703125,
        370.0
      ],
      "bbox_max": [
        1971.3634033203125,
        1988.4345703125,
        372.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2776.0,
      "bbox_min": [
        1962.2213134765625,
        1948.0792236328125,
        370.0
      ],
      "bbox_max": [
        1969.99951171875,
        1963.635498046875,
        372.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071012854576111,
        -0.7071123719215393,
        0.0
      ],
      "plane_d": -9.9783935546875,
      "bbox_min": [
        1962.2213134765625,
        1948.0792236328125,
        370.0
      ],
      "bbox_max": [
        1969.99951171875,
        1955.8572998046875,
        372.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2805.0,
      "bbox_min": [
        1963.635498046875,
        1887.2679443359375,
        370.0
      ],
      "bbox_max": [
        2079.60107421875,
        2003.2335205078125,
        372.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9238780736923218,
        0.3826870620250702,
        -0.0
      ],
      "plane_d": -2583.832763671875,
      "bbox_min": [
        1969.2923583984375,
        1892.9249267578125,
        370.0
      ],
      "bbox_max": [
        2073.944091796875,
        1997.57666015625,
        372.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238780736923218,
        -0.3826870620250702,
        0.0
      ],
      "plane_d": -1060.351318359375,
      "bbox_min": [
        1971.3634033203125,
        1988.4345703125,
        370.0
      ],
      "bbox_max": [
        1972.2213134765625,
        1990.505615234375,
        372.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826734721660614,
        0.9238837361335754,
        0.0
      ],
      "plane_d": -2542.48583984375,
      "bbox_min": [
        2064.802001953125,
        1892.9249267578125,
        370.0
      ],
      "bbox_max": [
        2073.944091796875,
        1895.853759765625,
        372.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826870620250702,
        0.9238780736923218,
        0.0
      ],
      "plane_d": -960.5721435546875,
      "bbox_min": [
        2064.802001953125,
        1894.9959716796875,
        370.0
      ],
      "bbox_max": [
        2066.873046875,
        1895.853759765625,
        372.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -374.9999694824219,
      "bbox_min": [
        1947.2630615234375,
        1870.8956298828125,
        372.5
      ],
      "bbox_max": [
        2079.60107421875,
        2003.2335205078125,
        665.0
      ],
      "face_count": 11
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2800.000244140625,
      "bbox_min": [
        1952.262451171875,
        1875.8948974609375,
        372.5
      ],
      "bbox_max": [
        2079.60107421875,
        2003.2335205078125,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 30.0,
      "bbox_min": [
        1952.262451171875,
        1875.8948974609375,
        372.5
      ],
      "bbox_max": [
        2068.84521484375,
        1992.477294921875,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1975.6563720703125,
        1875.8948974609375,
        372.5
      ],
      "bbox_max": [
        2068.84521484375,
        1955.8572998046875,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071051001548767,
        0.7071084976196289,
        0.0
      ],
      "plane_d": 77.9932861328125,
      "bbox_min": [
        1975.6563720703125,
        1897.8746337890625,
        372.5
      ],
      "bbox_max": [
        2033.63916015625,
        1955.8572998046875,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -32.0,
      "bbox_min": [
        1975.6563720703125,
        1915.19873046875,
        372.5
      ],
      "bbox_max": [
        2021.7950439453125,
        1955.8572998046875,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3637884259223938,
        0.748203456401825,
        0.5548419952392578
      ],
      "plane_d": -2387.54150390625,
      "bbox_min": [
        1991.3895263671875,
        1915.19873046875,
        372.5
      ],
      "bbox_max": [
        2021.7950439453125,
        1941.39697265625,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5045856833457947,
        0.35952863097190857,
        0.7849410772323608
      ],
      "plane_d": -2004.36962890625,
      "bbox_min": [
        1991.3895263671875,
        1915.19873046875,
        372.5
      ],
      "bbox_max": [
        2021.7950439453125,
        1941.39697265625,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5137051939964294,
        -0.31225311756134033,
        0.7991275191307068
      ],
      "plane_d": -735.439697265625,
      "bbox_min": [
        1991.3895263671875,
        1915.19873046875,
        372.5
      ],
      "bbox_max": [
        2021.7950439453125,
        1941.39697265625,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35740771889686584,
        0.6073290109634399,
        0.7095147967338562
      ],
      "plane_d": -2159.60791015625,
      "bbox_min": [
        1991.3895263671875,
        1928.38623046875,
        372.5
      ],
      "bbox_max": [
        2013.557373046875,
        1941.39697265625,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.21750731766223907,
        0.6525018215179443,
        0.7259007096290588
      ],
      "plane_d": -1101.71435546875,
      "bbox_min": [
        1991.3895263671875,
        1928.38623046875,
        372.5
      ],
      "bbox_max": [
        2003.12744140625,
        1941.39697265625,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8233370780944824,
        0.2744414806365967,
        0.4967876970767975
      ],
      "plane_d": 924.9917602539062,
      "bbox_min": [
        1991.3895263671875,
        1928.38623046875,
        372.5
      ],
      "bbox_max": [
        1995.1724853515625,
        1937.4725341796875,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.83591228723526,
        -0.2786460220813751,
        0.47287097573280334
      ],
      "plane_d": -1327.9442138671875,
      "bbox_min": [
        2015.2542724609375,
        1915.19873046875,
        372.5
      ],
      "bbox_max": [
        2017.906005859375,
        1924.21435546875,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.592004656791687,
        0.3767370283603668,
        0.7124602198600769
      ],
      "plane_d": -2186.705078125,
      "bbox_min": [
        2010.4439697265625,
        1924.21435546875,
        372.5
      ],
      "bbox_max": [
        2017.906005859375,
        1935.775634765625,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35740771889686584,
        0.6073290109634399,
        0.7095147967338562
      ],
      "plane_d": -2159.60791015625,
      "bbox_min": [
        2010.4439697265625,
        1933.93701171875,
        372.5
      ],
      "bbox_max": [
        2013.557373046875,
        1935.775634765625,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 118.0001220703125,
      "bbox_min": [
        2024.4466552734375,
        1875.8948974609375,
        372.5
      ],
      "bbox_max": [
        2068.84521484375,
        1894.9959716796875,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17280015349388123,
        -0.17280015349388123,
        0.9696804881095886
      ],
      "plane_d": -392.0101013183594,
      "bbox_min": [
        2047.1448974609375,
        1875.8948974609375,
        372.5
      ],
      "bbox_max": [
        2068.84521484375,
        1894.9959716796875,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826870620250702,
        0.9238780736923218,
        0.0
      ],
      "plane_d": -960.5721435546875,
      "bbox_min": [
        2059.802001953125,
        1892.9248046875,
        372.5
      ],
      "bbox_max": [
        2064.802001953125,
        1894.9959716796875,
        374.5291748046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826870620250702,
        0.9238780736923218,
        0.0
      ],
      "plane_d": -960.5721435546875,
      "bbox_min": [
        2059.802001953125,
        1890.0369873046875,
        373.5
      ],
      "bbox_max": [
        2068.84521484375,
        1894.9959716796875,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10071714222431183,
        -0.24314017593860626,
        0.9647481441497803
      ],
      "plane_d": 307.8013916015625,
      "bbox_min": [
        2066.873291015625,
        1890.9530029296875,
        373.5
      ],
      "bbox_max": [
        2068.84521484375,
        1892.9248046875,
        373.79107666015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2776.000244140625,
      "bbox_min": [
        2024.4466552734375,
        1885.853759765625,
        372.5
      ],
      "bbox_max": [
        2040.0030517578125,
        1893.6319580078125,
        373.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        2024.4466552734375,
        1885.853759765625,
        372.5
      ],
      "bbox_max": [
        2032.224853515625,
        1893.6319580078125,
        373.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071098685264587,
        -0.7071037888526917,
        0.0
      ],
      "plane_d": 9.988037109375,
      "bbox_min": [
        1952.262451171875,
        1948.0792236328125,
        372.5
      ],
      "bbox_max": [
        1971.3634033203125,
        1992.477294921875,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1728079617023468,
        0.17280647158622742,
        0.9696779847145081
      ],
      "plane_d": -365.61370849609375,
      "bbox_min": [
        1952.262451171875,
        1970.77734375,
        372.5
      ],
      "bbox_max": [
        1971.3634033203125,
        1992.477294921875,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238780736923218,
        -0.3826870620250702,
        0.0
      ],
      "plane_d": -1060.351318359375,
      "bbox_min": [
        1969.2923583984375,
        1983.4345703125,
        372.5
      ],
      "bbox_max": [
        1971.3634033203125,
        1988.4345703125,
        374.52923583984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238780736923218,
        -0.3826870620250702,
        0.0
      ],
      "plane_d": -1060.351318359375,
      "bbox_min": [
        1966.404541015625,
        1983.4345703125,
        373.5
      ],
      "bbox_max": [
        1971.3634033203125,
        1992.477294921875,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24314555525779724,
        -0.10072041302919388,
        0.9647464752197266
      ],
      "plane_d": 318.69561767578125,
      "bbox_min": [
        1967.3206787109375,
        1990.505615234375,
        373.5
      ],
      "bbox_max": [
        1969.2923583984375,
        1992.477294921875,
        373.79107666015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2776.0,
      "bbox_min": [
        1962.2213134765625,
        1948.0792236328125,
        372.5
      ],
      "bbox_max": [
        1969.99951171875,
        1963.635498046875,
        373.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071012854576111,
        -0.7071123719215393,
        0.0
      ],
      "plane_d": -9.9783935546875,
      "bbox_min": [
        1962.2213134765625,
        1948.0792236328125,
        372.5
      ],
      "bbox_max": [
        1969.99951171875,
        1955.8572998046875,
        373.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2805.0,
      "bbox_min": [
        1960.7476806640625,
        1884.3802490234375,
        372.5
      ],
      "bbox_max": [
        2079.60107421875,
        2003.2335205078125,
        375.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9238780736923218,
        0.3826870620250702,
        -0.0
      ],
      "plane_d": -2583.832763671875,
      "bbox_min": [
        1960.7476806640625,
        1884.3802490234375,
        372.5
      ],
      "bbox_max": [
        2078.115966796875,
        2001.74853515625,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1728072166442871,
        -0.1728072166442871,
        0.9696779847145081
      ],
      "plane_d": 322.3307800292969,
      "bbox_min": [
        1960.7476806640625,
        1988.4345703125,
        372.5
      ],
      "bbox_max": [
        1972.2213134765625,
        2001.74853515625,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238780736923218,
        -0.3826870620250702,
        0.0
      ],
      "plane_d": -1060.351318359375,
      "bbox_min": [
        1971.3634033203125,
        1988.4345703125,
        372.5
      ],
      "bbox_max": [
        1972.2213134765625,
        1990.505615234375,
        373.7911376953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238780736923218,
        -0.3826870620250702,
        0.0
      ],
      "plane_d": -1060.351318359375,
      "bbox_min": [
        1966.404541015625,
        1988.4345703125,
        373.2691650390625
      ],
      "bbox_max": [
        1972.2213134765625,
        1996.0916748046875,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24313946068286896,
        0.10071789473295212,
        0.964748203754425
      ],
      "plane_d": -82.28109741210938,
      "bbox_min": [
        1969.2923583984375,
        1989.91943359375,
        373.79107666015625
      ],
      "bbox_max": [
        1970.121337890625,
        1990.505615234375,
        374.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826734721660614,
        0.9238837361335754,
        0.0
      ],
      "plane_d": -2542.48583984375,
      "bbox_min": [
        2064.802001953125,
        1884.3802490234375,
        372.5
      ],
      "bbox_max": [
        2078.115966796875,
        1895.853759765625,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1728072166442871,
        -0.1728072166442871,
        0.9696779847145081
      ],
      "plane_d": 322.3307800292969,
      "bbox_min": [
        2064.802001953125,
        1884.3802490234375,
        372.5
      ],
      "bbox_max": [
        2078.115966796875,
        1895.853759765625,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826870620250702,
        0.9238780736923218,
        0.0
      ],
      "plane_d": -960.5721435546875,
      "bbox_min": [
        2064.802001953125,
        1894.9959716796875,
        372.5
      ],
      "bbox_max": [
        2066.873046875,
        1895.853759765625,
        373.7911376953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826870620250702,
        0.9238780736923218,
        0.0
      ],
      "plane_d": -960.5721435546875,
      "bbox_min": [
        2064.802001953125,
        1890.0369873046875,
        373.2691650390625
      ],
      "bbox_max": [
        2072.459228515625,
        1895.853759765625,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10070779919624329,
        -0.24313180148601532,
        0.9647512435913086
      ],
      "plane_d": -108.53544616699219,
      "bbox_min": [
        2066.287109375,
        1892.9248046875,
        373.79107666015625
      ],
      "bbox_max": [
        2066.873291015625,
        1893.7537841796875,
        374.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 11.1541748046875,
      "bbox_min": [
        1947.2630615234375,
        1870.8956298828125,
        375.0
      ],
      "bbox_max": [
        2073.345947265625,
        1996.978515625,
        665.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071080803871155,
        0.7071055173873901,
        0.0
      ],
      "plane_d": 119.1590576171875,
      "bbox_min": [
        1947.2630615234375,
        1870.8956298828125,
        375.0
      ],
      "bbox_max": [
        2073.345947265625,
        1986.3719482421875,
        665.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 104.154052734375,
      "bbox_min": [
        1947.2630615234375,
        1870.8956298828125,
        375.0
      ],
      "bbox_max": [
        2067.689208984375,
        1986.3719482421875,
        665.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1870.8956298828125,
      "bbox_min": [
        2018.1917724609375,
        1870.8956298828125,
        635.0
      ],
      "bbox_max": [
        2067.689208984375,
        1909.7864990234375,
        665.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071027159690857,
        0.7071108222007751,
        -0.0
      ],
      "plane_d": -2794.999267578125,
      "bbox_min": [
        2050.011474609375,
        1892.1087646484375,
        635.0
      ],
      "bbox_max": [
        2067.689208984375,
        1909.7864990234375,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 648.0,
      "bbox_min": [
        2050.011474609375,
        1892.1087646484375,
        648.0
      ],
      "bbox_max": [
        2067.689208984375,
        1909.7864990234375,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071080803871155,
        -0.7071055173873901,
        -1.512640210421523e-06
      ],
      "plane_d": -3.849968910217285,
      "bbox_min": [
        1947.2630615234375,
        1870.8956298828125,
        375.0
      ],
      "bbox_max": [
        2058.741455078125,
        1986.3719482421875,
        665.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1947.2630615234375,
      "bbox_min": [
        1947.2630615234375,
        1941.82421875,
        650.0
      ],
      "bbox_max": [
        1947.2630615234375,
        1963.037353515625,
        665.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.36380255222320557,
        0.36380425095558167,
        0.8574930429458618
      ],
      "plane_d": -1979.9510498046875,
      "bbox_min": [
        1947.2630615234375,
        1870.8956298828125,
        375.0
      ],
      "bbox_max": [
        2058.741455078125,
        1982.3739013671875,
        665.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2805.000244140625,
      "bbox_min": [
        1947.2630615234375,
        1870.8956298828125,
        375.0
      ],
      "bbox_max": [
        2044.9527587890625,
        1967.878173828125,
        662.0001220703125
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.6974859237670898,
        0.6974859237670898,
        0.16439847648143768
      ],
      "plane_d": -2813.688720703125,
      "bbox_min": [
        1947.2630615234375,
        1870.8956298828125,
        375.0
      ],
      "bbox_max": [
        2018.347900390625,
        1941.82421875,
        662.0001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5070080757141113,
        0.8615391254425049,
        0.026328522711992264
      ],
      "plane_d": -2695.9931640625,
      "bbox_min": [
        1995.1724853515625,
        1916.2593994140625,
        375.0
      ],
      "bbox_max": [
        2018.347900390625,
        1938.992919921875,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071067094802856,
        5.753044661105378e-06
      ],
      "plane_d": -2787.502197265625,
      "bbox_min": [
        1995.1724853515625,
        1916.2593994140625,
        375.0
      ],
      "bbox_max": [
        2018.347900390625,
        1938.992919921875,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9480223059654236,
        -0.31601718068122864,
        -0.03724071383476257
      ],
      "plane_d": -1290.9697265625,
      "bbox_min": [
        1995.1724853515625,
        1916.2593994140625,
        375.0
      ],
      "bbox_max": [
        2018.347900390625,
        1938.992919921875,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.460689902305603,
        0.8819450736045837,
        0.09968864917755127
      ],
      "plane_d": -824.6478881835938,
      "bbox_min": [
        1995.1724853515625,
        1934.750244140625,
        375.0
      ],
      "bbox_max": [
        2004.2410888671875,
        1938.992919921875,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3069612383842468,
        0.9208554029464722,
        0.24041666090488434
      ],
      "plane_d": -1260.805908203125,
      "bbox_min": [
        1995.1724853515625,
        1934.750244140625,
        375.0
      ],
      "bbox_max": [
        2003.12744140625,
        1938.992919921875,
        383.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8369823098182678,
        0.5326346755027771,
        0.1255428045988083
      ],
      "plane_d": -2760.933349609375,
      "bbox_min": [
        2011.71875,
        1924.21435546875,
        375.0
      ],
      "bbox_max": [
        2017.906005859375,
        1933.93701171875,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071108222007751,
        0.7071027159690857,
        -0.0
      ],
      "plane_d": -2745.000244140625,
      "bbox_min": [
        1947.2630615234375,
        1870.8956298828125,
        650.0
      ],
      "bbox_max": [
        2018.1917724609375,
        1941.82421875,
        662.0001220703125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071108222007751,
        0.7071027159690857,
        -0.0
      ],
      "plane_d": -2750.00048828125,
      "bbox_min": [
        1947.2630615234375,
        1870.8956298828125,
        650.0
      ],
      "bbox_max": [
        2018.1917724609375,
        1941.82421875,
        662.0001220703125
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -78.0,
      "bbox_min": [
        1953.736083984375,
        1875.2471923828125,
        655.0
      ],
      "bbox_max": [
        2010.3045654296875,
        1931.815673828125,
        662.0001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 33.0,
      "bbox_min": [
        1953.736083984375,
        1917.673583984375,
        655.0
      ],
      "bbox_max": [
        1967.878173828125,
        1931.815673828125,
        662.0001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -18.0001220703125,
      "bbox_min": [
        1953.736083984375,
        1928.2801513671875,
        655.0
      ],
      "bbox_max": [
        1957.2716064453125,
        1931.815673828125,
        661.9998168945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 93.0,
      "bbox_min": [
        2006.76904296875,
        1875.2471923828125,
        655.0
      ],
      "bbox_max": [
        2010.3045654296875,
        1878.78271484375,
        662.0001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2790.000244140625,
      "bbox_min": [
        1947.2630615234375,
        1870.8956298828125,
        635.0
      ],
      "bbox_max": [
        2058.741455078125,
        1982.3739013671875,
        665.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071043252944946,
        -0.7071092128753662,
        0.0
      ],
      "plane_d": -69.990478515625,
      "bbox_min": [
        1947.2630615234375,
        1870.8956298828125,
        635.0
      ],
      "bbox_max": [
        2022.325439453125,
        1944.543701171875,
        665.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071092128753662,
        0.7071043252944946,
        -5.7925312546558416e-08
      ],
      "plane_d": 40.009681701660156,
      "bbox_min": [
        1947.2630615234375,
        1895.0462646484375,
        635.0
      ],
      "bbox_max": [
        2001.1121826171875,
        1944.543701171875,
        665.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071108222007751,
        0.7071027159690857,
        -0.0
      ],
      "plane_d": -2745.000244140625,
      "bbox_min": [
        1972.8280029296875,
        1895.0462646484375,
        658.9999389648438
      ],
      "bbox_max": [
        1994.0411376953125,
        1916.25927734375,
        665.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2750.000244140625,
      "bbox_min": [
        1972.8280029296875,
        1895.0462646484375,
        658.9999389648438
      ],
      "bbox_max": [
        1994.0411376953125,
        1916.25927734375,
        665.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        -0.0
      ],
      "plane_d": -2750.0,
      "bbox_min": [
        1947.2630615234375,
        1916.25927734375,
        658.9999389648438
      ],
      "bbox_max": [
        1972.8280029296875,
        1941.82421875,
        665.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 33.0,
      "bbox_min": [
        1953.736083984375,
        1917.673583984375,
        658.9999389648438
      ],
      "bbox_max": [
        1967.878173828125,
        1931.815673828125,
        665.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -18.0001220703125,
      "bbox_min": [
        1953.736083984375,
        1928.2801513671875,
        659.0
      ],
      "bbox_max": [
        1957.2716064453125,
        1931.815673828125,
        665.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2745.000244140625,
      "bbox_min": [
        1994.0411376953125,
        1870.8956298828125,
        659.0
      ],
      "bbox_max": [
        2018.1917724609375,
        1895.0462646484375,
        665.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071012854576111,
        0.7071122527122498,
        0.0
      ],
      "plane_d": -2749.999267578125,
      "bbox_min": [
        1994.0411376953125,
        1870.8956298828125,
        659.0
      ],
      "bbox_max": [
        2018.1917724609375,
        1895.0462646484375,
        665.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -78.0,
      "bbox_min": [
        1996.1624755859375,
        1885.853759765625,
        659.0000610351562
      ],
      "bbox_max": [
        1999.697998046875,
        1889.3892822265625,
        665.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070762515068054,
        -0.7071372866630554,
        0.0
      ],
      "plane_d": -86.3785400390625,
      "bbox_min": [
        1997.22314453125,
        1920.8555908203125,
        635.0
      ],
      "bbox_max": [
        2058.741455078125,
        1982.3739013671875,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 21.5001220703125,
      "bbox_min": [
        1997.22314453125,
        1926.865966796875,
        635.0
      ],
      "bbox_max": [
        2022.325439453125,
        1982.3739013671875,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -65.0,
      "bbox_min": [
        2008.1832275390625,
        1926.865966796875,
        635.0
      ],
      "bbox_max": [
        2022.325439453125,
        1941.008056640625,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2795.000244140625,
      "bbox_min": [
        2008.1832275390625,
        1930.4014892578125,
        635.0
      ],
      "bbox_max": [
        2022.325439453125,
        1941.008056640625,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -50.0001220703125,
      "bbox_min": [
        2008.1832275390625,
        1937.4725341796875,
        635.0
      ],
      "bbox_max": [
        2011.71875,
        1941.008056640625,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071372866630554,
        -0.7070762515068054,
        0.0
      ],
      "plane_d": -11.62158203125,
      "bbox_min": [
        1997.22314453125,
        1973.8885498046875,
        635.0
      ],
      "bbox_max": [
        2005.7083740234375,
        1982.3739013671875,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 650.0,
      "bbox_min": [
        1997.22314453125,
        1973.8885498046875,
        650.0
      ],
      "bbox_max": [
        2005.7083740234375,
        1982.3739013671875,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070762515068054,
        0.7071372866630554,
        0.0
      ],
      "plane_d": 96.3785400390625,
      "bbox_min": [
        2050.256103515625,
        1920.8555908203125,
        635.0
      ],
      "bbox_max": [
        2058.741455078125,
        1929.3408203125,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 650.0,
      "bbox_min": [
        2050.256103515625,
        1920.8555908203125,
        650.0
      ],
      "bbox_max": [
        2058.741455078125,
        1929.3408203125,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        1970.70654296875,
        1894.339111328125,
        370.0
      ],
      "bbox_max": [
        2114.95654296875,
        2038.5888671875,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070946097373962,
        -0.7071189880371094,
        0.0
      ],
      "plane_d": 2829.99853515625,
      "bbox_min": [
        1970.70654296875,
        1894.339111328125,
        370.0
      ],
      "bbox_max": [
        2114.95654296875,
        2038.5888671875,
        660.0
      ],
      "face_count": 14
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -370.0,
      "bbox_min": [
        1981.311767578125,
        1904.9461669921875,
        370.0
      ],
      "bbox_max": [
        2114.95654296875,
        2038.5888671875,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -19.0,
      "bbox_min": [
        1981.311767578125,
        1904.9461669921875,
        370.0
      ],
      "bbox_max": [
        2114.95654296875,
        2038.5888671875,
        660.0
      ],
      "face_count": 16
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 14.0,
      "bbox_min": [
        1981.311767578125,
        1991.212646484375,
        370.0
      ],
      "bbox_max": [
        2032.224853515625,
        2038.5888671875,
        660.0
      ],
      "face_count": 16
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        -0.0
      ],
      "plane_d": -2835.0,
      "bbox_min": [
        2014.5472412109375,
        1991.212646484375,
        370.0
      ],
      "bbox_max": [
        2032.224853515625,
        2008.890380859375,
        660.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -530.0,
      "bbox_min": [
        2014.5472412109375,
        1991.212646484375,
        410.0
      ],
      "bbox_max": [
        2032.224853515625,
        2008.890380859375,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -470.0,
      "bbox_min": [
        2014.5472412109375,
        1991.212646484375,
        410.0
      ],
      "bbox_max": [
        2032.224853515625,
        2008.890380859375,
        525.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -410.0,
      "bbox_min": [
        2014.5472412109375,
        1991.212646484375,
        410.0
      ],
      "bbox_max": [
        2032.224853515625,
        2008.890380859375,
        465.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 465.0,
      "bbox_min": [
        2014.5472412109375,
        1991.212646484375,
        460.0
      ],
      "bbox_max": [
        2032.224853515625,
        2008.890380859375,
        465.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000008344650269,
        0.5000008344650269,
        -0.7071056962013245
      ],
      "plane_d": -1679.382568359375,
      "bbox_min": [
        2014.5472412109375,
        1991.212646484375,
        460.0
      ],
      "bbox_max": [
        2021.6182861328125,
        1998.2838134765625,
        465.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 525.0,
      "bbox_min": [
        2014.5472412109375,
        1991.212646484375,
        520.0
      ],
      "bbox_max": [
        2032.224853515625,
        2008.890380859375,
        525.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000008344650269,
        0.5000008344650269,
        -0.7071056962013245
      ],
      "plane_d": -1636.9561767578125,
      "bbox_min": [
        2014.5472412109375,
        1991.212646484375,
        520.0
      ],
      "bbox_max": [
        2021.6182861328125,
        1998.2838134765625,
        525.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -590.0,
      "bbox_min": [
        2014.5472412109375,
        1991.212646484375,
        580.0
      ],
      "bbox_max": [
        2032.224853515625,
        2008.890380859375,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 585.0,
      "bbox_min": [
        2014.5472412109375,
        1991.212646484375,
        580.0
      ],
      "bbox_max": [
        2032.224853515625,
        2008.890380859375,
        585.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000008344650269,
        0.5000008344650269,
        -0.7071056962013245
      ],
      "plane_d": -1594.52978515625,
      "bbox_min": [
        2014.5472412109375,
        1991.212646484375,
        580.0
      ],
      "bbox_max": [
        2021.6182861328125,
        1998.2838134765625,
        585.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 645.0,
      "bbox_min": [
        2014.5472412109375,
        1991.212646484375,
        640.0
      ],
      "bbox_max": [
        2032.224853515625,
        2008.890380859375,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000008344650269,
        0.5000008344650269,
        -0.7071056962013245
      ],
      "plane_d": -1552.103515625,
      "bbox_min": [
        2014.5472412109375,
        1991.212646484375,
        640.0
      ],
      "bbox_max": [
        2021.6182861328125,
        1998.2838134765625,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 1.1541748046875,
      "bbox_min": [
        1981.311767578125,
        1994.856201171875,
        370.0
      ],
      "bbox_max": [
        2025.044677734375,
        2038.5888671875,
        660.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -384.9999694824219,
      "bbox_min": [
        1981.311767578125,
        2001.92724609375,
        385.0
      ],
      "bbox_max": [
        2017.9737548828125,
        2038.5888671875,
        420.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071057558059692,
        -0.7071077823638916,
        0.0
      ],
      "plane_d": 28.0040283203125,
      "bbox_min": [
        1981.311767578125,
        2020.90966796875,
        385.0
      ],
      "bbox_max": [
        1998.9908447265625,
        2038.5888671875,
        420.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 640.0,
      "bbox_min": [
        2000.2950439453125,
        1994.856201171875,
        640.0
      ],
      "bbox_max": [
        2025.044677734375,
        2019.60595703125,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -8.845947265625,
      "bbox_min": [
        2007.3662109375,
        1994.856201171875,
        640.0
      ],
      "bbox_max": [
        2025.044677734375,
        2012.53466796875,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070946097373962,
        0.7071189880371094,
        0.0
      ],
      "plane_d": 88.951171875,
      "bbox_min": [
        2021.6175537109375,
        1904.9461669921875,
        370.0
      ],
      "bbox_max": [
        2114.95654296875,
        1998.2838134765625,
        660.0
      ],
      "face_count": 15
    },
    {
      "plane_normal": [
        0.7071189880371094,
        -0.7070945501327515,
        0.0
      ],
      "plane_d": -94.0489501953125,
      "bbox_min": [
        2067.580322265625,
        1904.9461669921875,
        370.0
      ],
      "bbox_max": [
        2114.95654296875,
        1955.8572998046875,
        660.0
      ],
      "face_count": 15
    },
    {
      "plane_normal": [
        0.7071189880371094,
        0.7070945501327515,
        0.0
      ],
      "plane_d": -2835.00146484375,
      "bbox_min": [
        2067.580322265625,
        1938.1796875,
        370.0
      ],
      "bbox_max": [
        2085.258056640625,
        1955.8572998046875,
        660.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -530.0,
      "bbox_min": [
        2067.580322265625,
        1938.1796875,
        410.0
      ],
      "bbox_max": [
        2085.258056640625,
        1955.8572998046875,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -470.0,
      "bbox_min": [
        2067.580322265625,
        1938.1796875,
        410.0
      ],
      "bbox_max": [
        2085.258056640625,
        1955.8572998046875,
        525.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -410.0,
      "bbox_min": [
        2067.580322265625,
        1938.1796875,
        410.0
      ],
      "bbox_max": [
        2085.258056640625,
        1955.8572998046875,
        465.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 465.0,
      "bbox_min": [
        2067.580322265625,
        1938.1796875,
        460.0
      ],
      "bbox_max": [
        2085.2578125,
        1955.8572998046875,
        465.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4999879002571106,
        0.5000051259994507,
        -0.7071117162704468
      ],
      "plane_d": -1679.3612060546875,
      "bbox_min": [
        2067.580322265625,
        1938.1796875,
        460.0
      ],
      "bbox_max": [
        2074.6513671875,
        1945.250732421875,
        465.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 525.0,
      "bbox_min": [
        2067.580322265625,
        1938.1796875,
        520.0
      ],
      "bbox_max": [
        2085.2578125,
        1955.8572998046875,
        525.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4999879002571106,
        0.5000051259994507,
        -0.7071117162704468
      ],
      "plane_d": -1636.9344482421875,
      "bbox_min": [
        2067.580322265625,
        1938.1796875,
        520.0
      ],
      "bbox_max": [
        2074.6513671875,
        1945.250732421875,
        525.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -590.0,
      "bbox_min": [
        2067.580322265625,
        1938.1796875,
        580.0
      ],
      "bbox_max": [
        2085.2578125,
        1955.8572998046875,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 585.0,
      "bbox_min": [
        2067.580322265625,
        1938.1796875,
        580.0
      ],
      "bbox_max": [
        2085.2578125,
        1955.8572998046875,
        585.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4999879002571106,
        0.5000051259994507,
        -0.7071117162704468
      ],
      "plane_d": -1594.5078125,
      "bbox_min": [
        2067.580322265625,
        1938.1796875,
        580.0
      ],
      "bbox_max": [
        2074.6513671875,
        1945.250732421875,
        585.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 645.0,
      "bbox_min": [
        2067.580322265625,
        1938.1796875,
        640.0
      ],
      "bbox_max": [
        2085.2578125,
        1955.8572998046875,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4999879002571106,
        0.5000051259994507,
        -0.7071117162704468
      ],
      "plane_d": -1552.0810546875,
      "bbox_min": [
        2067.580322265625,
        1938.1796875,
        640.0
      ],
      "bbox_max": [
        2074.6513671875,
        1945.250732421875,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071037888526917,
        0.7071098685264587,
        0.0
      ],
      "plane_d": 110.141845703125,
      "bbox_min": [
        2071.224609375,
        1904.9461669921875,
        370.0
      ],
      "bbox_max": [
        2114.95654296875,
        1948.677490234375,
        660.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -384.9999694824219,
      "bbox_min": [
        2079.003173828125,
        1904.9461669921875,
        385.0
      ],
      "bbox_max": [
        2114.95654296875,
        1940.899169921875,
        420.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071083784103394,
        0.707105278968811,
        0.0
      ],
      "plane_d": 136.006103515625,
      "bbox_min": [
        2097.279296875,
        1904.9461669921875,
        385.0
      ],
      "bbox_max": [
        2114.95654296875,
        1922.6234130859375,
        420.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 640.0,
      "bbox_min": [
        2071.224609375,
        1923.2216796875,
        640.0
      ],
      "bbox_max": [
        2096.6806640625,
        1948.677490234375,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.707109808921814,
        0.7071037888526917,
        0.0
      ],
      "plane_d": 99.1661376953125,
      "bbox_min": [
        2071.224609375,
        1930.999755859375,
        640.0
      ],
      "bbox_max": [
        2088.90234375,
        1948.677490234375,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24828201532363892,
        0.24828201532363892,
        -0.9363291263580322
      ],
      "plane_d": -567.0653076171875,
      "bbox_min": [
        2021.6175537109375,
        1945.25048828125,
        370.0
      ],
      "bbox_max": [
        2074.6513671875,
        1998.2838134765625,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24828201532363892,
        0.24828201532363892,
        -0.9363291263580322
      ],
      "plane_d": -454.705810546875,
      "bbox_min": [
        2021.6175537109375,
        1945.25048828125,
        455.62469482421875
      ],
      "bbox_max": [
        2074.6513671875,
        1998.2838134765625,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -590.0,
      "bbox_min": [
        2021.6175537109375,
        1945.25048828125,
        575.6246948242188
      ],
      "bbox_max": [
        2074.6513671875,
        1998.2838134765625,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.707105278968811,
        0.7071083188056946,
        0.0
      ],
      "plane_d": 43.993896484375,
      "bbox_min": [
        2032.224365234375,
        1955.8570556640625,
        575.6246948242188
      ],
      "bbox_max": [
        2064.044677734375,
        1987.6771240234375,
        590.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -64.0,
      "bbox_min": [
        2046.36669921875,
        1955.8570556640625,
        575.6248168945312
      ],
      "bbox_max": [
        2064.044677734375,
        1973.5350341796875,
        590.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24828200042247772,
        0.24828200042247772,
        -0.9363290667533875
      ],
      "plane_d": -398.526123046875,
      "bbox_min": [
        2021.6175537109375,
        1945.25048828125,
        635.6246337890625
      ],
      "bbox_max": [
        2074.6513671875,
        1998.2838134765625,
        650.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.707105278968811,
        -0.7071083784103394,
        0.0
      ],
      "plane_d": -43.9937744140625,
      "bbox_min": [
        2021.6175537109375,
        1945.25048828125,
        635.6246337890625
      ],
      "bbox_max": [
        2074.6513671875,
        1998.2838134765625,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071083188056946,
        0.707105278968811,
        0.0
      ],
      "plane_d": 29.006103515625,
      "bbox_min": [
        2021.6175537109375,
        1980.60546875,
        635.6246337890625
      ],
      "bbox_max": [
        2039.2958984375,
        1998.2838134765625,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 64.0,
      "bbox_min": [
        2046.36669921875,
        1945.25048828125,
        635.6248168945312
      ],
      "bbox_max": [
        2074.6513671875,
        1973.5350341796875,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -79.0,
      "bbox_min": [
        2056.973388671875,
        1945.25048828125,
        635.6248779296875
      ],
      "bbox_max": [
        2074.6513671875,
        1962.928466796875,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -470.0,
      "bbox_min": [
        2021.6175537109375,
        1945.25048828125,
        455.62469482421875
      ],
      "bbox_max": [
        2074.6513671875,
        1998.2838134765625,
        530.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.707105278968811,
        0.7071083188056946,
        0.0
      ],
      "plane_d": 43.993896484375,
      "bbox_min": [
        2032.224365234375,
        1955.8570556640625,
        455.62469482421875
      ],
      "bbox_max": [
        2064.044677734375,
        1987.6771240234375,
        470.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -64.0,
      "bbox_min": [
        2046.36669921875,
        1955.8570556640625,
        455.62481689453125
      ],
      "bbox_max": [
        2064.044677734375,
        1973.5350341796875,
        470.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24828200042247772,
        0.24828200042247772,
        -0.9363290667533875
      ],
      "plane_d": -510.8856201171875,
      "bbox_min": [
        2021.6175537109375,
        1945.25048828125,
        515.6246337890625
      ],
      "bbox_max": [
        2074.6513671875,
        1998.2838134765625,
        530.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -530.0,
      "bbox_min": [
        2021.6175537109375,
        1945.25048828125,
        515.6246337890625
      ],
      "bbox_max": [
        2074.6513671875,
        1998.2838134765625,
        530.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.707105278968811,
        -0.7071083784103394,
        0.0
      ],
      "plane_d": -43.9937744140625,
      "bbox_min": [
        2021.6175537109375,
        1945.25048828125,
        515.6246337890625
      ],
      "bbox_max": [
        2074.6513671875,
        1998.2838134765625,
        530.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071083188056946,
        0.707105278968811,
        0.0
      ],
      "plane_d": 29.006103515625,
      "bbox_min": [
        2021.6175537109375,
        1980.60546875,
        515.6246337890625
      ],
      "bbox_max": [
        2039.2958984375,
        1998.2838134765625,
        530.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 64.0,
      "bbox_min": [
        2046.36669921875,
        1945.25048828125,
        515.6248168945312
      ],
      "bbox_max": [
        2074.6513671875,
        1973.5350341796875,
        530.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -79.0,
      "bbox_min": [
        2056.973388671875,
        1945.25048828125,
        515.6248779296875
      ],
      "bbox_max": [
        2074.6513671875,
        1962.928466796875,
        530.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3483176529407501,
        -0.3483176529407501,
        0.8702583312988281
      ],
      "plane_d": 1071.3109130859375,
      "bbox_min": [
        2029.395751953125,
        1953.028564453125,
        370.0
      ],
      "bbox_max": [
        2066.873291015625,
        1990.5057373046875,
        388.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071011066436768,
        0.7071124911308289,
        0.0
      ],
      "plane_d": 59.9771728515625,
      "bbox_min": [
        2030.1029052734375,
        1953.7357177734375,
        370.0
      ],
      "bbox_max": [
        2066.166259765625,
        1989.7987060546875,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071189880371094,
        -0.7070945501327515,
        -4.352215910330415e-05
      ],
      "plane_d": -67.03279113769531,
      "bbox_min": [
        2048.488037109375,
        1953.7357177734375,
        370.0
      ],
      "bbox_max": [
        2066.166259765625,
        1971.413818359375,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071090936660767,
        0.7071044445037842,
        0.0
      ],
      "plane_d": 41.0093994140625,
      "bbox_min": [
        2030.1029052734375,
        1967.170654296875,
        370.0
      ],
      "bbox_max": [
        2052.731201171875,
        1989.7987060546875,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071189880371094,
        -0.7070945501327515,
        -3.0492372388835065e-05
      ],
      "plane_d": -48.03766632080078,
      "bbox_min": [
        2035.052978515625,
        1967.170654296875,
        370.0
      ],
      "bbox_max": [
        2052.731201171875,
        1984.848876953125,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067094802856,
        -0.7071067094802856,
        0.0
      ],
      "plane_d": -49.0,
      "bbox_min": [
        2029.395751953125,
        1953.028564453125,
        370.8485107421875
      ],
      "bbox_max": [
        2066.873291015625,
        1990.5057373046875,
        388.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071090936660767,
        -0.7071044445037842,
        0.0
      ],
      "plane_d": -41.0093994140625,
      "bbox_min": [
        2029.395751953125,
        1966.4635009765625,
        370.8485107421875
      ],
      "bbox_max": [
        2053.438232421875,
        1990.5057373046875,
        388.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067094802856,
        0.7071067094802856,
        0.0
      ],
      "plane_d": 40.0,
      "bbox_min": [
        2029.395751953125,
        1972.1201171875,
        370.8485107421875
      ],
      "bbox_max": [
        2047.7813720703125,
        1990.5057373046875,
        388.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3483176529407501,
        -0.3483176529407501,
        0.8702583909034729
      ],
      "plane_d": 1068.264892578125,
      "bbox_min": [
        2029.395751953125,
        1972.1201171875,
        374.3485107421875
      ],
      "bbox_max": [
        2047.7813720703125,
        1990.5057373046875,
        388.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067094802856,
        0.7071067094802856,
        0.0
      ],
      "plane_d": 48.0,
      "bbox_min": [
        2035.052978515625,
        1966.4635009765625,
        370.8487548828125
      ],
      "bbox_max": [
        2053.438232421875,
        1984.848876953125,
        388.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3483167886734009,
        -0.3483167886734009,
        0.8702590465545654
      ],
      "plane_d": 1068.26123046875,
      "bbox_min": [
        2035.052978515625,
        1966.4635009765625,
        374.3486328125
      ],
      "bbox_max": [
        2053.438232421875,
        1984.848876953125,
        388.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071021199226379,
        -0.7071112990379333,
        0.0
      ],
      "plane_d": -59.9815673828125,
      "bbox_min": [
        2042.8311767578125,
        1953.028564453125,
        370.8487854003906
      ],
      "bbox_max": [
        2066.873291015625,
        1977.0706787109375,
        388.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 59.0,
      "bbox_min": [
        2042.8311767578125,
        1958.6854248046875,
        370.8487854003906
      ],
      "bbox_max": [
        2061.216552734375,
        1977.0706787109375,
        388.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3482867181301117,
        -0.34834685921669006,
        0.8702590465545654
      ],
      "plane_d": 1068.2587890625,
      "bbox_min": [
        2042.8311767578125,
        1958.6854248046875,
        374.3487854003906
      ],
      "bbox_max": [
        2061.216552734375,
        1977.0706787109375,
        388.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067094802856,
        -0.7071067094802856,
        0.0
      ],
      "plane_d": -68.0,
      "bbox_min": [
        2048.488037109375,
        1953.028564453125,
        370.8487854003906
      ],
      "bbox_max": [
        2066.873291015625,
        1971.413818359375,
        388.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071044445037842,
        0.7071090936660767,
        0.0
      ],
      "plane_d": 66.99072265625,
      "bbox_min": [
        2048.488037109375,
        1953.028564453125,
        370.8487854003906
      ],
      "bbox_max": [
        2066.873291015625,
        1971.413818359375,
        388.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34834685921669006,
        -0.3482867181301117,
        0.8702590465545654
      ],
      "plane_d": 1068.26416015625,
      "bbox_min": [
        2048.488037109375,
        1953.028564453125,
        374.3487854003906
      ],
      "bbox_max": [
        2066.873291015625,
        1971.413818359375,
        388.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -370.0,
      "bbox_min": [
        1970.70654296875,
        1894.339111328125,
        370.0
      ],
      "bbox_max": [
        2097.279296875,
        2020.9097900390625,
        660.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071037888526917,
        0.7071098685264587,
        0.0
      ],
      "plane_d": 110.141845703125,
      "bbox_min": [
        1970.70654296875,
        1894.339111328125,
        370.0
      ],
      "bbox_max": [
        2097.279296875,
        2020.9097900390625,
        660.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.7071083784103394,
        0.707105278968811,
        0.0
      ],
      "plane_d": 136.006103515625,
      "bbox_min": [
        2068.396240234375,
        1894.339111328125,
        385.0
      ],
      "bbox_max": [
        2097.279296875,
        1923.2218017578125,
        413.75018310546875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -384.9999694824219,
      "bbox_min": [
        2068.396240234375,
        1894.339111328125,
        385.0
      ],
      "bbox_max": [
        2097.279296875,
        1923.2218017578125,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 1.1541748046875,
      "bbox_min": [
        1970.70654296875,
        1912.614990234375,
        370.0
      ],
      "bbox_max": [
        2079.003173828125,
        2020.9097900390625,
        660.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -384.9999694824219,
      "bbox_min": [
        1970.70654296875,
        1991.3216552734375,
        385.0
      ],
      "bbox_max": [
        2000.295166015625,
        2020.9097900390625,
        413.74951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071057558059692,
        -0.7071077823638916,
        0.0
      ],
      "plane_d": 28.0040283203125,
      "bbox_min": [
        1970.70654296875,
        2010.3045654296875,
        385.0
      ],
      "bbox_max": [
        1981.311767578125,
        2020.9097900390625,
        413.74951171875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.24828201532363892,
        0.24828201532363892,
        -0.9363291263580322
      ],
      "plane_d": -567.0653076171875,
      "bbox_min": [
        1989.689453125,
        1912.614990234375,
        370.0
      ],
      "bbox_max": [
        2079.003173828125,
        2001.92724609375,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24828201532363892,
        0.24828201532363892,
        -0.9363291263580322
      ],
      "plane_d": -454.705810546875,
      "bbox_min": [
        1989.689453125,
        1912.614990234375,
        450.0
      ],
      "bbox_max": [
        2079.003173828125,
        2001.92724609375,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -590.0,
      "bbox_min": [
        1989.689453125,
        1912.614990234375,
        570.0
      ],
      "bbox_max": [
        2079.003173828125,
        2001.92724609375,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -64.0,
      "bbox_min": [
        2021.6182861328125,
        1945.250732421875,
        570.0
      ],
      "bbox_max": [
        2046.36669921875,
        1969.9989013671875,
        590.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.707105278968811,
        0.7071083188056946,
        0.0
      ],
      "plane_d": 43.993896484375,
      "bbox_min": [
        2021.6182861328125,
        1959.3929443359375,
        570.0
      ],
      "bbox_max": [
        2032.224365234375,
        1969.9989013671875,
        590.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 64.0,
      "bbox_min": [
        1989.689453125,
        1912.614990234375,
        630.0
      ],
      "bbox_max": [
        2079.003173828125,
        2001.92724609375,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -79.0,
      "bbox_min": [
        2035.7603759765625,
        1912.614990234375,
        630.0
      ],
      "bbox_max": [
        2079.003173828125,
        1955.8570556640625,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2482801079750061,
        0.24828295409679413,
        -0.9363293051719666
      ],
      "plane_d": -398.52392578125,
      "bbox_min": [
        2035.7603759765625,
        1934.6441650390625,
        630.0
      ],
      "bbox_max": [
        2056.973388671875,
        1955.8570556640625,
        635.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 640.0,
      "bbox_min": [
        2060.6181640625,
        1912.614990234375,
        640.0
      ],
      "bbox_max": [
        2079.003173828125,
        1930.999755859375,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.707109808921814,
        0.7071037888526917,
        0.0
      ],
      "plane_d": 99.1661376953125,
      "bbox_min": [
        2060.6181640625,
        1920.39306640625,
        640.0
      ],
      "bbox_max": [
        2071.224609375,
        1930.999755859375,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071083188056946,
        0.707105278968811,
        0.0
      ],
      "plane_d": 29.006103515625,
      "bbox_min": [
        1989.689453125,
        1959.3929443359375,
        630.0
      ],
      "bbox_max": [
        2032.224365234375,
        2001.92724609375,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.707105278968811,
        -0.7071083784103394,
        0.0
      ],
      "plane_d": -43.9937744140625,
      "bbox_min": [
        2011.01171875,
        1959.3929443359375,
        630.0
      ],
      "bbox_max": [
        2032.224365234375,
        1980.60546875,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24828200042247772,
        0.24828200042247772,
        -0.9363290667533875
      ],
      "plane_d": -398.526123046875,
      "bbox_min": [
        2011.01171875,
        1959.3929443359375,
        630.0
      ],
      "bbox_max": [
        2032.224365234375,
        1980.60546875,
        635.6246948242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 640.0,
      "bbox_min": [
        1989.689453125,
        1984.2506103515625,
        640.0
      ],
      "bbox_max": [
        2007.3662109375,
        2001.92724609375,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -8.845947265625,
      "bbox_min": [
        1996.7606201171875,
        1984.2506103515625,
        640.0
      ],
      "bbox_max": [
        2007.3662109375,
        1994.856201171875,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -470.0,
      "bbox_min": [
        2011.01171875,
        1934.6441650390625,
        450.0
      ],
      "bbox_max": [
        2056.973388671875,
        1980.60546875,
        530.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -64.0,
      "bbox_min": [
        2021.6182861328125,
        1945.250732421875,
        450.0
      ],
      "bbox_max": [
        2046.36669921875,
        1969.9989013671875,
        470.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.707105278968811,
        0.7071083188056946,
        0.0
      ],
      "plane_d": 43.993896484375,
      "bbox_min": [
        2021.6182861328125,
        1959.3929443359375,
        450.0
      ],
      "bbox_max": [
        2032.224365234375,
        1969.9989013671875,
        470.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 64.0,
      "bbox_min": [
        2011.01171875,
        1934.6441650390625,
        510.0
      ],
      "bbox_max": [
        2056.973388671875,
        1980.60546875,
        530.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -79.0,
      "bbox_min": [
        2035.7603759765625,
        1934.6441650390625,
        510.0
      ],
      "bbox_max": [
        2056.973388671875,
        1955.8570556640625,
        530.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2482801079750061,
        0.24828295409679413,
        -0.9363293051719666
      ],
      "plane_d": -510.8834228515625,
      "bbox_min": [
        2035.7603759765625,
        1934.6441650390625,
        510.0
      ],
      "bbox_max": [
        2056.973388671875,
        1955.8570556640625,
        530.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -530.0,
      "bbox_min": [
        2035.7603759765625,
        1934.6441650390625,
        530.0
      ],
      "bbox_max": [
        2056.973388671875,
        1955.8570556640625,
        530.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.707105278968811,
        -0.7071083784103394,
        0.0
      ],
      "plane_d": -43.9937744140625,
      "bbox_min": [
        2011.01171875,
        1959.3929443359375,
        510.0
      ],
      "bbox_max": [
        2032.224365234375,
        1980.60546875,
        530.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071083188056946,
        0.707105278968811,
        0.0
      ],
      "plane_d": 29.006103515625,
      "bbox_min": [
        2011.01171875,
        1959.3929443359375,
        510.0
      ],
      "bbox_max": [
        2032.224365234375,
        1980.60546875,
        530.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24828200042247772,
        0.24828200042247772,
        -0.9363290667533875
      ],
      "plane_d": -510.8856201171875,
      "bbox_min": [
        2011.01171875,
        1959.3929443359375,
        510.0
      ],
      "bbox_max": [
        2032.224365234375,
        1980.60546875,
        530.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -530.0,
      "bbox_min": [
        2011.01171875,
        1959.3929443359375,
        530.0
      ],
      "bbox_max": [
        2032.224365234375,
        1980.60546875,
        530.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071027159690857,
        0.7071108222007751,
        0.0
      ],
      "plane_d": 83.98388671875,
      "bbox_min": [
        1989.689453125,
        1912.614990234375,
        370.0
      ],
      "bbox_max": [
        2075.46728515625,
        1998.3927001953125,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -382.0,
      "bbox_min": [
        2049.902587890625,
        1912.614990234375,
        370.0
      ],
      "bbox_max": [
        2075.46728515625,
        1941.7152099609375,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071123719215393,
        0.7071012854576111,
        0.0
      ],
      "plane_d": -2825.0009765625,
      "bbox_min": [
        2060.6181640625,
        1919.6859130859375,
        370.0
      ],
      "bbox_max": [
        2075.46728515625,
        1930.999755859375,
        382.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 99.154052734375,
      "bbox_min": [
        2060.6181640625,
        1920.39306640625,
        370.0
      ],
      "bbox_max": [
        2067.689208984375,
        1927.464111328125,
        382.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071312069892883,
        -0.7070823311805725,
        0.0
      ],
      "plane_d": -99.251708984375,
      "bbox_min": [
        2067.689208984375,
        1927.464111328125,
        370.0
      ],
      "bbox_max": [
        2071.224609375,
        1930.999755859375,
        382.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -385.0,
      "bbox_min": [
        2052.73095703125,
        1912.614990234375,
        382.0
      ],
      "bbox_max": [
        2075.46728515625,
        1938.88671875,
        385.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.7071123719215393,
        0.7071012854576111,
        0.0
      ],
      "plane_d": -2825.0009765625,
      "bbox_min": [
        2052.73095703125,
        1919.6859130859375,
        382.0
      ],
      "bbox_max": [
        2075.46728515625,
        1938.88671875,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 99.154052734375,
      "bbox_min": [
        2052.73095703125,
        1920.39306640625,
        382.0
      ],
      "bbox_max": [
        2067.689208984375,
        1932.5228271484375,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070762515068054,
        0.7071372866630554,
        0.0
      ],
      "plane_d": 94.87841796875,
      "bbox_min": [
        2052.73095703125,
        1923.3304443359375,
        382.0
      ],
      "bbox_max": [
        2061.92333984375,
        1932.5228271484375,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071372866630554,
        -0.7070762515068054,
        0.0
      ],
      "plane_d": -97.1217041015625,
      "bbox_min": [
        2060.50927734375,
        1923.3304443359375,
        382.0
      ],
      "bbox_max": [
        2061.92333984375,
        1926.1588134765625,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071372866630554,
        0.7070762515068054,
        -0.0
      ],
      "plane_d": -2819.004150390625,
      "bbox_min": [
        2060.50927734375,
        1924.74462890625,
        382.0
      ],
      "bbox_max": [
        2061.92333984375,
        1926.1588134765625,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070762515068054,
        0.7071372866630554,
        0.0
      ],
      "plane_d": 85.8782958984375,
      "bbox_min": [
        2052.73095703125,
        1929.6944580078125,
        382.0
      ],
      "bbox_max": [
        2055.559326171875,
        1932.5228271484375,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071372866630554,
        -0.7070762515068054,
        0.0
      ],
      "plane_d": -88.12158203125,
      "bbox_min": [
        2054.145263671875,
        1929.6944580078125,
        382.0
      ],
      "bbox_max": [
        2055.559326171875,
        1932.5228271484375,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071372866630554,
        0.7070762515068054,
        -0.0
      ],
      "plane_d": -2819.00390625,
      "bbox_min": [
        2054.145263671875,
        1931.108642578125,
        382.0
      ],
      "bbox_max": [
        2055.559326171875,
        1932.5228271484375,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071372866630554,
        0.7070762515068054,
        0.0
      ],
      "plane_d": 95.1220703125,
      "bbox_min": [
        2059.094970703125,
        1929.6944580078125,
        382.0
      ],
      "bbox_max": [
        2068.287353515625,
        1938.88671875,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070762515068054,
        -0.7071372866630554,
        0.0
      ],
      "plane_d": -96.8779296875,
      "bbox_min": [
        2065.458984375,
        1929.6944580078125,
        382.0
      ],
      "bbox_max": [
        2068.287353515625,
        1932.5228271484375,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070762515068054,
        0.7071372866630554,
        -0.0
      ],
      "plane_d": -2827.995849609375,
      "bbox_min": [
        2065.458984375,
        1929.6944580078125,
        382.0
      ],
      "bbox_max": [
        2068.287353515625,
        1932.5228271484375,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071372866630554,
        -0.7070762515068054,
        -0.0
      ],
      "plane_d": 2826.004150390625,
      "bbox_min": [
        2065.458984375,
        1929.6944580078125,
        382.0
      ],
      "bbox_max": [
        2066.873046875,
        1931.108642578125,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070762515068054,
        -0.7071372866630554,
        -0.0
      ],
      "plane_d": 2825.99609375,
      "bbox_min": [
        2059.094970703125,
        1936.058349609375,
        382.0
      ],
      "bbox_max": [
        2061.92333984375,
        1938.88671875,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070762515068054,
        0.7071372866630554,
        0.0
      ],
      "plane_d": 85.8780517578125,
      "bbox_min": [
        2059.094970703125,
        1936.058349609375,
        382.0
      ],
      "bbox_max": [
        2061.92333984375,
        1938.88671875,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071372866630554,
        -0.7070762515068054,
        0.0
      ],
      "plane_d": -88.1220703125,
      "bbox_min": [
        2060.50927734375,
        1936.058349609375,
        382.0
      ],
      "bbox_max": [
        2061.92333984375,
        1938.88671875,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071372866630554,
        0.7070762515068054,
        -0.0
      ],
      "plane_d": -2828.00390625,
      "bbox_min": [
        2060.50927734375,
        1937.4725341796875,
        382.0
      ],
      "bbox_max": [
        2061.92333984375,
        1938.88671875,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -24.0,
      "bbox_min": [
        1989.689453125,
        1949.493408203125,
        370.0
      ],
      "bbox_max": [
        2049.195068359375,
        1998.3927001953125,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -382.0,
      "bbox_min": [
        1989.689453125,
        1973.5350341796875,
        370.0
      ],
      "bbox_max": [
        2018.082763671875,
        1998.3927001953125,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2825.000244140625,
      "bbox_min": [
        1996.7606201171875,
        1984.2506103515625,
        370.0
      ],
      "bbox_max": [
        2007.3671875,
        1998.3927001953125,
        382.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -8.845947265625,
      "bbox_min": [
        1996.7606201171875,
        1984.2506103515625,
        370.0
      ],
      "bbox_max": [
        2003.8316650390625,
        1991.3216552734375,
        382.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 8.845947265625,
      "bbox_min": [
        2003.8316650390625,
        1991.3216552734375,
        370.0
      ],
      "bbox_max": [
        2007.3671875,
        1994.857177734375,
        382.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -385.0,
      "bbox_min": [
        1989.689453125,
        1976.3634033203125,
        382.0
      ],
      "bbox_max": [
        2015.2542724609375,
        1998.3927001953125,
        385.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2825.000244140625,
      "bbox_min": [
        1996.7606201171875,
        1976.3634033203125,
        382.0
      ],
      "bbox_max": [
        2015.2542724609375,
        1998.3927001953125,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -8.845947265625,
      "bbox_min": [
        1996.7606201171875,
        1976.3634033203125,
        382.0
      ],
      "bbox_max": [
        2008.890380859375,
        1991.3216552734375,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070762515068054,
        0.7071372866630554,
        0.0
      ],
      "plane_d": 19.87841796875,
      "bbox_min": [
        1999.697998046875,
        1976.3634033203125,
        382.0
      ],
      "bbox_max": [
        2008.890380859375,
        1985.5557861328125,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071372866630554,
        -0.7070762515068054,
        0.0
      ],
      "plane_d": -22.1217041015625,
      "bbox_min": [
        2007.4761962890625,
        1976.3634033203125,
        382.0
      ],
      "bbox_max": [
        2008.890380859375,
        1979.19189453125,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2819.000244140625,
      "bbox_min": [
        2007.4761962890625,
        1977.7777099609375,
        382.0
      ],
      "bbox_max": [
        2008.890380859375,
        1979.19189453125,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 11.0,
      "bbox_min": [
        1999.697998046875,
        1982.7274169921875,
        382.0
      ],
      "bbox_max": [
        2002.5263671875,
        1985.5557861328125,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2819.000244140625,
      "bbox_min": [
        2001.1121826171875,
        1982.7274169921875,
        382.0
      ],
      "bbox_max": [
        2002.5263671875,
        1985.5557861328125,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -13.0,
      "bbox_min": [
        2001.1121826171875,
        1982.7274169921875,
        382.0
      ],
      "bbox_max": [
        2002.5263671875,
        1984.1416015625,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -13.0,
      "bbox_min": [
        2006.0618896484375,
        1982.7274169921875,
        382.0
      ],
      "bbox_max": [
        2015.2542724609375,
        1991.9197998046875,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070762515068054,
        0.7071372866630554,
        0.0
      ],
      "plane_d": 10.8779296875,
      "bbox_min": [
        2006.0618896484375,
        1989.0914306640625,
        382.0
      ],
      "bbox_max": [
        2008.890380859375,
        1991.9197998046875,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070762515068054,
        -0.7071372866630554,
        0.0
      ],
      "plane_d": 2825.99951171875,
      "bbox_min": [
        2006.0618896484375,
        1989.0914306640625,
        382.0
      ],
      "bbox_max": [
        2008.890380859375,
        1991.9197998046875,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2828.000244140625,
      "bbox_min": [
        2007.4761962890625,
        1990.505615234375,
        382.0
      ],
      "bbox_max": [
        2008.890380859375,
        1991.9197998046875,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 20.0,
      "bbox_min": [
        2012.4259033203125,
        1982.7274169921875,
        382.0
      ],
      "bbox_max": [
        2015.2542724609375,
        1985.5557861328125,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2826.000244140625,
      "bbox_min": [
        2012.4259033203125,
        1982.7274169921875,
        382.0
      ],
      "bbox_max": [
        2015.2542724609375,
        1985.5557861328125,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2828.0,
      "bbox_min": [
        2013.840087890625,
        1982.7274169921875,
        382.0
      ],
      "bbox_max": [
        2015.2542724609375,
        1985.5557861328125,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -22.0,
      "bbox_min": [
        2013.840087890625,
        1982.7274169921875,
        382.0
      ],
      "bbox_max": [
        2015.2542724609375,
        1984.1416015625,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34831249713897705,
        -0.3483211100101471,
        0.8702591061592102
      ],
      "plane_d": 1071.306884765625,
      "bbox_min": [
        2025.8609619140625,
        1949.493408203125,
        370.0
      ],
      "bbox_max": [
        2049.195068359375,
        1972.8271484375,
        374.3487854003906
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071011066436768,
        0.7071124911308289,
        0.0
      ],
      "plane_d": 59.9771728515625,
      "bbox_min": [
        2029.04296875,
        1952.6754150390625,
        370.0
      ],
      "bbox_max": [
        2048.488037109375,
        1972.1201171875,
        370.8487854003906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071189880371094,
        -0.7070945501327515,
        -4.352215910330415e-05
      ],
      "plane_d": -67.03279113769531,
      "bbox_min": [
        2047.427734375,
        1952.6754150390625,
        370.0
      ],
      "bbox_max": [
        2048.488037109375,
        1953.7357177734375,
        370.8487854003906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071189880371094,
        -0.7070945501327515,
        -3.0492372388835065e-05
      ],
      "plane_d": -48.03766632080078,
      "bbox_min": [
        2029.04296875,
        1966.1103515625,
        370.0
      ],
      "bbox_max": [
        2035.052978515625,
        1972.1201171875,
        370.8487548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071090936660767,
        0.7071044445037842,
        0.0
      ],
      "plane_d": 41.0093994140625,
      "bbox_min": [
        2029.04296875,
        1971.0601806640625,
        370.0
      ],
      "bbox_max": [
        2030.1029052734375,
        1972.1201171875,
        370.8485107421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 59.0,
      "bbox_min": [
        2025.8609619140625,
        1949.493408203125,
        370.0
      ],
      "bbox_max": [
        2049.195068359375,
        1972.8271484375,
        374.3487854003906
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 67.0,
      "bbox_min": [
        2039.2958984375,
        1949.493408203125,
        370.0
      ],
      "bbox_max": [
        2049.195068359375,
        1959.392578125,
        374.3487854003906
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -68.0,
      "bbox_min": [
        2044.9527587890625,
        1949.493408203125,
        370.0
      ],
      "bbox_max": [
        2049.195068359375,
        1953.7357177734375,
        374.3487854003906
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2825.000244140625,
      "bbox_min": [
        2044.9527587890625,
        1949.493408203125,
        370.0
      ],
      "bbox_max": [
        2049.195068359375,
        1953.7357177734375,
        374.3487854003906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -373.5,
      "bbox_min": [
        2044.9527587890625,
        1949.493408203125,
        373.0
      ],
      "bbox_max": [
        2049.195068359375,
        1953.7357177734375,
        374.3487854003906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.31618380546569824,
        -0.3162384033203125,
        0.8944389820098877
      ],
      "plane_d": 929.6834716796875,
      "bbox_min": [
        2044.9527587890625,
        1949.493408203125,
        373.0
      ],
      "bbox_max": [
        2046.3670654296875,
        1950.9075927734375,
        373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34834685921669006,
        -0.3482867181301117,
        0.8702590465545654
      ],
      "plane_d": 1068.26416015625,
      "bbox_min": [
        2047.427734375,
        1951.96826171875,
        373.5
      ],
      "bbox_max": [
        2049.195068359375,
        1953.7357177734375,
        374.3487854003906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071312069892883,
        -0.7070823311805725,
        0.0
      ],
      "plane_d": -60.0977783203125,
      "bbox_min": [
        2039.2958984375,
        1955.1502685546875,
        370.0
      ],
      "bbox_max": [
        2043.5382080078125,
        1959.392578125,
        374.3487854003906
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7070457339286804,
        -0.7071678042411804,
        -0.0
      ],
      "plane_d": 2824.99462890625,
      "bbox_min": [
        2039.2958984375,
        1955.1502685546875,
        370.0
      ],
      "bbox_max": [
        2043.5382080078125,
        1959.392578125,
        374.3487854003906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -373.5,
      "bbox_min": [
        2039.2958984375,
        1955.1502685546875,
        373.0
      ],
      "bbox_max": [
        2043.5382080078125,
        1959.392578125,
        374.3487854003906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.31623297929763794,
        -0.31623297929763794,
        0.8944236040115356
      ],
      "plane_d": 929.7791748046875,
      "bbox_min": [
        2039.2958984375,
        1955.1502685546875,
        373.0
      ],
      "bbox_max": [
        2040.710205078125,
        1956.564453125,
        373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3482867181301117,
        -0.34834685921669006,
        0.8702590465545654
      ],
      "plane_d": 1068.2587890625,
      "bbox_min": [
        2041.7708740234375,
        1957.6251220703125,
        373.5
      ],
      "bbox_max": [
        2043.5382080078125,
        1959.392578125,
        374.3487854003906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -41.0,
      "bbox_min": [
        2025.8609619140625,
        1962.928466796875,
        370.0
      ],
      "bbox_max": [
        2035.7598876953125,
        1972.8271484375,
        374.3487548828125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7070823311805725,
        0.7071312069892883,
        0.0
      ],
      "plane_d": 39.90234375,
      "bbox_min": [
        2025.8609619140625,
        1968.5853271484375,
        370.0
      ],
      "bbox_max": [
        2030.1029052734375,
        1972.8271484375,
        374.3485107421875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2825.000244140625,
      "bbox_min": [
        2025.8609619140625,
        1968.5853271484375,
        370.0
      ],
      "bbox_max": [
        2030.1029052734375,
        1972.8271484375,
        374.3485107421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -373.5,
      "bbox_min": [
        2025.8609619140625,
        1968.5853271484375,
        373.0
      ],
      "bbox_max": [
        2030.1029052734375,
        1972.8271484375,
        374.3485107421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.31623297929763794,
        -0.31623297929763794,
        0.8944236040115356
      ],
      "plane_d": 929.7791748046875,
      "bbox_min": [
        2025.8609619140625,
        1968.5853271484375,
        373.0
      ],
      "bbox_max": [
        2027.275146484375,
        1969.99951171875,
        373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3483176529407501,
        -0.3483176529407501,
        0.8702583909034729
      ],
      "plane_d": 1068.264892578125,
      "bbox_min": [
        2028.3358154296875,
        1971.0601806640625,
        373.5
      ],
      "bbox_max": [
        2030.1029052734375,
        1972.8271484375,
        374.3485107421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071312069892883,
        -0.7070823311805725,
        0.0
      ],
      "plane_d": -49.0977783203125,
      "bbox_min": [
        2031.517822265625,
        1962.928466796875,
        370.0
      ],
      "bbox_max": [
        2035.7598876953125,
        1967.170654296875,
        374.3487548828125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7070823311805725,
        0.7071312069892883,
        0.0
      ],
      "plane_d": 47.90234375,
      "bbox_min": [
        2031.517822265625,
        1962.928466796875,
        370.0
      ],
      "bbox_max": [
        2035.7598876953125,
        1967.170654296875,
        374.3487548828125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2825.000244140625,
      "bbox_min": [
        2031.517822265625,
        1962.928466796875,
        370.0
      ],
      "bbox_max": [
        2035.7598876953125,
        1967.170654296875,
        374.3487548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -373.5,
      "bbox_min": [
        2031.517822265625,
        1962.928466796875,
        373.0
      ],
      "bbox_max": [
        2035.7598876953125,
        1967.170654296875,
        374.3487548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.31623297929763794,
        -0.31623297929763794,
        0.8944236040115356
      ],
      "plane_d": 929.7791748046875,
      "bbox_min": [
        2031.517822265625,
        1962.928466796875,
        373.0
      ],
      "bbox_max": [
        2032.9320068359375,
        1964.3426513671875,
        373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3483167886734009,
        -0.3483167886734009,
        0.8702590465545654
      ],
      "plane_d": 1068.26123046875,
      "bbox_min": [
        2033.99267578125,
        1965.4033203125,
        373.5
      ],
      "bbox_max": [
        2035.7598876953125,
        1967.170654296875,
        374.3487548828125
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [],
  "tutorial_messages": []
}